/* eslint-disable react/no-array-index-key */
import React from 'react';
import HTMLReactParser from 'html-react-parser';
import sanitizeHTML from './purify';
import { parsedCollection, initCollection } from './parse';
import coreReplacements, {
    learningCenterReplacements,
} from './parse/replacements';
import { assembleReplacements } from './parse/helpers';

const parseHTML = (
    htmlString,
    target = ['core'],
    pageData = {},
    initParseCollection = false
) => 
{
    if (initParseCollection) initCollection();

    const maybeSanitizedHtml = target.includes('core')
        ? htmlString
        : sanitizeHTML(htmlString, target);

    return {
        parsed: HTMLReactParser.default(maybeSanitizedHtml, {
            replace: assembleReplacements([
                ...(target.includes('core') ? coreReplacements(pageData) : []),
                ...(target.includes('learningCenter')
                    ? learningCenterReplacements(pageData)
                    : []),
            ]),
            addReplacements: assembleReplacements,
        }),
        parsedCollection,
    };
};

export default parseHTML;

const parseHtmlArray = (htmlArray, target = ['core'], pageData = {}) =>
    htmlArray
        .map((bloc) =>
            typeof bloc === 'string'
                ? parseHTML(bloc, target, pageData).parsed
                : bloc
        )
        .map((compo, ix) =>
            React.isValidElement(compo)
                ? React.createElement(compo.type, {
                      ...compo.props,
                      key: `parsed-${ix}`,
                  })
                : compo
        );

/**
 * fnParseHTMLWithPageData:
 * @param {object} pageData - data specific to the calling page
 * @param { object } pageData.location - location data
 * @param { object } pageData.location.pathname - pathname for current page
 * @returns {object } functions parseHTMLWithPageData( htmlString ), parseHtmlArrayWithPageData( htmlArray )
 */
const fnParseHTMLWithPageData = (pageData, target = ['core']) => 
{
    const parseHTMLWithPageData = (htmlString) =>
        parseHTML(htmlString, target, pageData);
    const parseHtmlArrayWithPageData = (htmlArray) =>
        parseHtmlArray(htmlArray, target, pageData);

    return {
        parseHTMLWithPageData,
        parseHtmlArrayWithPageData,
        parse: (html) =>
            Array.isArray(html)
                ? parseHtmlArrayWithPageData(html)
                : parseHTMLWithPageData(html),
    };
};

export { parseHtmlArray, fnParseHTMLWithPageData };
